<section *ngIf="!tokenValid">
    <div class="rbt-conatct-area bg-gradient-11 rbt-section-gap">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="section-title text-center mb--60">
                        <h2 class="title">{{'umustlogin' | translate}}</h2>
                        <br><br>
                        <div>
                            <button type="submit" class="rbt-btn btn-gradient hover-transform-none" routerLink="/login">
                                <span class="icon-reverse-wrapper">
                                    <span class="btn-text">{{'login' | translate}}</span>
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section *ngIf="tokenValid && isTeacher === 'false'">
    <div class="rbt-conatct-area bg-gradient-11 rbt-section-gap">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="section-title text-center mb--60">
                        <h2 class="title">{{'noAuth' | translate}}</h2>
                        <br><br>
                        <div>
                            <button type="submit" class="rbt-btn btn-gradient hover-transform-none" routerLink="/home">
                                <span class="icon-reverse-wrapper">
                                    <span class="btn-text">{{'home' | translate}}</span>
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section *ngIf="tokenValid && isTeacher === 'true'">
    <div class="rbt-dashboard-area rbt-section-gapBottom" style="margin: 50px 0;">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <!-- Start Dashboard Top  -->
                    <div class="rbt-dashboard-content-wrapper">
                        <div class="tutor-bg-photo bg_image bg_image--22 height-350"></div>
                        <!-- Start Tutor Information  -->
                        <div class="rbt-tutor-information">
                            <div class="rbt-tutor-information-left">
                                <div class="thumbnail rbt-avatars size-lg">
                                    <img style="aspect-ratio: 1 / 1;" [src]="this.baseService.appUrl + this.teacher.profileImg" onerror=" this.onerror=null;this.src='assets/images/team/avatar.jpg';" alt="Instructor">
                                </div>
                                <div class="tutor-content">
                                    <h5 class="title">{{this.userFullName}}</h5>
                                    <!-- <div class="rbt-review">
                                        <div class="rating">
                                            <i class="fas fa-star"></i>
                                            <i class="fas fa-star"></i>
                                            <i class="fas fa-star"></i>
                                            <i class="fas fa-star"></i>
                                            <i class="fas fa-star"></i>
                                        </div>
                                        <span class="rating-count"> (15 Reviews)</span>
                                    </div> -->
                                </div>
                            </div>
                            <div class="rbt-tutor-information-right">
                                <button type="submit" class="rbt-btn btn-gradient hover-transform-none" routerLink="/create-course/add/0">
                                    <span class="icon-reverse-wrapper">
                                        <span class="btn-text">{{'Create a New Course' | translate}}</span>
                                    </span>
                                </button>
                            </div>
                        </div>
                        <!-- End Tutor Information  -->
                    </div>
                    <!-- End Dashboard Top  -->

                    <div class="row g-5">
                        <div class="col-lg-3">
                            <!-- Start Dashboard Sidebar  -->
                            <div class="rbt-default-sidebar sticky-top rbt-shadow-box rbt-gradient-border">
                                <div class="inner">
                                    <div class="content-item-content">

                                        <div class="rbt-default-sidebar-wrapper">
                                            <div class="section-title mb--20">
                                                <h6 class="rbt-title-style-2">{{'Welcome' | translate}} {{this.userFullName}}</h6>
                                            </div>
                                            <nav class="mainmenu-nav">
                                                <ul class="dashboard-mainmenu rbt-default-sidebar-list">
                                                    <li><a (click)="viewProfile(this.teacherId)"><i class="feather-user"></i><span>{{'View Profile' | translate}}</span></a></li>
                                                    <li><a (click)="viewCourses(this.teacherId)"><i class="feather-monitor"></i><span>{{'MyCourses' | translate}}</span></a></li>
                                                    <li><a (click)="ViewPayments(this.teacherId)"><i class="feather-dollar-sign"></i><span>{{'payments' | translate}}</span></a></li>
                                                </ul>
                                            </nav>

                                            <div class="section-title mt--40 mb--20">
                                                <h6 class="rbt-title-style-2">{{'UserSettings' | translate}}</h6>
                                            </div>

                                            <nav class="mainmenu-nav">
                                                <ul class="dashboard-mainmenu rbt-default-sidebar-list">
                                                    <li><a (click)="viewSettings(this.teacherId)"><i class="feather-settings"></i><span>{{'Settings' | translate}}</span></a></li>
                                                   
                                                </ul>
                                            </nav>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <!-- End Dashboard Sidebar  -->
                        </div>

                        <div class="col-lg-9">
                            <div class="rbt-dashboard-content bg-color-white rbt-shadow-box">
                                <div class="content">

                                    <div class="section-title">
                                        <h4 class="rbt-title-style-3">{{'Settings' | translate}}</h4>
                                    </div>

                                    <div class="advance-tab-button mb--30">
                                        <ul class="nav nav-tabs tab-button-style-2 justify-content-start" id="settinsTab-4" role="tablist">
                                            <li role="presentation">
                                                <a href="#" class="tab-button active" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile" role="tab" aria-controls="profile" aria-selected="true">
                                                    <span class="title">{{'View Profile' | translate}}</span>
                                                </a>
                                            </li>
                                            <li role="presentation">
                                                <a href="#" class="tab-button" id="bank-tab" data-bs-toggle="tab" data-bs-target="#bank" role="tab" aria-controls="bank" aria-selected="false">
                                                    <span class="title">{{'bank' | translate}}</span>
                                                </a>
                                            </li>
                                            <li role="presentation">
                                                <a href="#" class="tab-button" id="password-tab" data-bs-toggle="tab" data-bs-target="#password" role="tab" aria-controls="password" aria-selected="false">
                                                    <span class="title">{{'Password' | translate}}</span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>

                                    <div class="tab-content">
                                        <div class="tab-pane fade active show" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                                            <div class="rbt-dashboard-content-wrapper">
                                                <div class="tutor-bg-photo bg_image bg_image--22 height-245"></div>
                                                <!-- Start Tutor Information  -->
                                                <div class="rbt-tutor-information">
                                                    <div class="rbt-tutor-information-left">
                                                        <div class="thumbnail rbt-avatars size-lg position-relative">
                                                            <img style="aspect-ratio: 1 / 1;" [src]="this.baseService.appUrl + this.teacher.profileImg" onerror=" this.onerror=null;this.src='assets/images/team/avatar.jpg';" alt="Instructor">
                                                            <div class="rbt-edit-photo-inner">
                                                                <button class="rbt-edit-photo" title="Upload Photo">
                                                                    <label style="cursor: pointer;" for="profilePic"><i class="feather-camera"></i></label>
                                                                    <input style="opacity: 0;display: none;cursor: pointer;" name="profilePic" id="profilePic" type="file" class="inputfile" accept="image/x-png,image/gif,image/jpeg"
                                                                    (change)="profilePic($event)" />

                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <!-- <div class="rbt-tutor-information-right">
                                                        <div class="tutor-btn">
                                                            <input style="opacity: 0;display: none;cursor: pointer;" name="coverPic" id="coverPic" type="file" class="inputfile" accept="image/x-png,image/gif,image/jpeg"
                                                            (change)="coverPic($event)" />
                                                            <a class="rbt-btn btn-sm btn-border color-white radius-round-10">{{'Edit Cover Photo' | translate}}
                                                            </a>
                                                        </div>
                                                    </div> -->
                                                </div>
                                                <!-- End Tutor Information  -->
                                            </div>
                                            <!-- Start Profile Row  -->
                                            <form action="#" class="rbt-profile-row rbt-default-form row row--15">
                                                <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                                                    <div class="rbt-form-group">
                                                        <label for="firstname">{{'First Name' | translate}}</label>
                                                        <input name="firstname" id="firstname" type="text" [(ngModel)]="teacher.name" ngModel #firstname="ngModel">
                                                    </div>
                                                </div>
                                                <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                                                    <div class="rbt-form-group">
                                                        <label for="lastname">{{'Last Name' | translate}}</label>
                                                        <input name="lastname" id="lastname" type="text" [(ngModel)]="teacher.surname" ngModel #lastname="ngModel">
                                                    </div>
                                                </div>
                                                <div class="col-lg-6 col-md-6 col-sm-6 col-12" style="margin-top: 20px;">
                                                    <div class="rbt-form-group">
                                                        <label for="username">{{'Email' | translate}}</label>
                                                        <input name="Email" id="Email" type="email" [(ngModel)]="teacher.emailAddress" ngModel #Email="ngModel" [email]="true">
                                                    </div>
                                                </div>
                                                <div class="col-lg-6 col-md-6 col-sm-6 col-12" style="margin-top: 20px;">
                                                    <div class="rbt-form-group">
                                                        <label for="phonenumber">{{'Phone Number' | translate}}</label>
                                                        <input name="mobile" id="mobile" type="text" [(ngModel)]="teacher.mobile" ngModel #mobile="ngModel">
                                                    </div>
                                                </div>
                                                <div class="col-12">
                                                    <div class="rbt-form-group" style="margin-top: 20px;">
                                                        <label for="bio">{{'Bio' | translate}}</label>
                                                        <textarea id="bio" cols="20" rows="5" name="bio" [(ngModel)]="teacher.bio" ngModel #bio="ngModel"></textarea>
                                                    </div>
                                                </div>
                                                <div class="col-12 mt--20">
                                                    <div class="rbt-form-group">
                                                        <button class="rbt-btn btn-gradient" [class.spinner]="loading" (click)="saveTeacher()" [disabled]="loading">{{'Update' | translate}}</button>
                                                    </div>
                                                </div>
                                            </form>
                                            <!-- End Profile Row  -->
                                        </div>

                                        <div class="tab-pane fade" id="password" role="tabpanel" aria-labelledby="password-tab">
                                            <form #passForm="ngForm" id="passForm" novalidate class="rbt-profile-row rbt-default-form row row--15">
                                                <div class="col-12">
                                                    <div class="rbt-form-group passForm">
                                                        <input id="currentPassword" name="currentPassword"  type="password" placeholder="{{'currentPassword' | translate}}" #input1 [(ngModel)]="changePassword.currentPassword" required ngModel #currentPassword="ngModel">
                                                        <div class="rev_pass"><i class="feather-eye" style="position: absolute;cursor: pointer;" (click)="changeInput1(input1)"></i></div>
                                                    </div>
                                                </div>
                                                <div class="col-12">
                                                    <div class="rbt-form-group passForm"> 
                                                        <input id="newPassword" type="password" name="newPassword" #input2 placeholder="{{'newPassword' | translate}}" [(ngModel)]="changePassword.newPassword" required ngModel #newPassword="ngModel">
                                                        <div class="rev_pass"><i class="feather-eye" style="position: absolute;cursor: pointer;" (click)="changeInput2(input2)"></i></div>
                                                    </div>
                                                </div>
                                                <div class="col-12">
                                                    <div class="rbt-form-group passForm">
                                                        <input id="confirmNewPassword" name="confirmNewPassword"  type="password" #input3 placeholder="{{'confirmNewPassword' | translate}}" [(ngModel)]="changePassword.confirmNewPassword" required ngModel #confirmNewPassword="ngModel">
                                                        <div class="rev_pass"><i class="feather-eye" style="position: absolute;cursor: pointer;" (click)="changeInput3(input3)"></i></div>
                                                    </div>
                                                    <small class="d-block mt_dec--5" *ngIf="changePassword.confirmNewPassword != changePassword.newPassword"><i class="feather-info" style="margin-left: 5px;"></i> كلمات المرور غير متشابهة</small>
                                                </div>
                                                <div class="col-12 mt--10">

                                                    <button class="rbt-btn btn-gradient" [class.spinner]="loading" (click)="changePass()" [disabled]="!(passForm.valid && passForm.dirty) || (changePassword.confirmNewPassword != changePassword.newPassword) || loading">{{'UpdatePassword' | translate}}</button>

                                                    <!-- <div class="rbt-form-group">
                                                        <button type="submit" class="rbt-btn btn-gradient hover-transform-none text-center" style="margin-left: 15px;" (click)="changePass()">
                                                            <span class="icon-reverse-wrapper">
                                                                <span class="btn-text">{{'UpdatePassword' | translate}}</span>
                                                            <span class="btn-icon"><i class="feather-arrow-right"></i></span>
                                                            <span class="btn-icon"><i class="feather-arrow-right"></i></span>
                                                            </span>
                                                        </button>
                                                    </div> -->
                                                </div>
                                            </form>
                                        </div>

                                        <div class="tab-pane fade" id="bank" role="tabpanel" aria-labelledby="bank-tab">
                                            <form #bankForm="ngForm" id="bankForm" novalidate class="rbt-profile-row rbt-default-form row row--15">
                                                <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                                                    <div class="rbt-form-group">
                                                        <label for="fullname">{{'fullname' | translate}}</label>
                                                        <input name="fullname" id="fullname" type="text" [(ngModel)]="teacherBankInfo.fullName" ngModel #fullname="ngModel" required>
                                                    </div>
                                                </div>

                                                <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                                                    <div class="rbt-form-group">
                                                        <label for="bankName">{{'bankName' | translate}}</label>
                                                        <input name="bankName" id="bankName" type="text" [(ngModel)]="teacherBankInfo.bankName" ngModel #bankName="ngModel" required>
                                                    </div>
                                                </div>

                                                <div class="col-lg-6 col-md-6 col-sm-6 col-12" style="margin-top: 20px;">
                                                    <div class="rbt-form-group">
                                                        <label for="bankAccountNo">{{'bankAccountNo' | translate}}</label>
                                                        <input name="bankAccountNo" id="bankAccountNo" type="text" [(ngModel)]="teacherBankInfo.bankAccountNo" ngModel #bankAccountNo="ngModel" required>
                                                    </div>
                                                </div>

                                                <div class="col-lg-6 col-md-6 col-sm-6 col-12" style="margin-top: 20px;">
                                                    <div class="rbt-form-group">
                                                        <label for="iBAN">{{'iban' | translate}}</label>
                                                        <input name="iBAN" id="iBAN" type="text" [(ngModel)]="teacherBankInfo.iban" ngModel #iBAN="ngModel" required>
                                                    </div>
                                                </div>

                                                <div class="col-12 mt--20">
                                                    <div class="rbt-form-group">
                                                        <button class="rbt-btn btn-gradient" [class.spinner]="loading" (click)="saveTeacherBankInfo()" [disabled]="loading || bankForm.invalid">{{'Save' | translate}}</button>
                                                    </div>
                                                </div>
                                            </form>

                                            <hr style="margin: 25px 0;">
                                            <h4 class="rbt-title-style-3" style="border-bottom: 0;">{{'previousBankData' | translate}}</h4>
                                            <div class="perDataCard" *ngFor="let info of teacherBankInfos | paginate: { itemsPerPage: 3, currentPage: p }" style="position: relative;">
                                                <div class="rbt-profile-row rbt-default-form row">
                                                    <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                                                        <div class="rbt-form-group">
                                                            <label for="fullname">{{'fullname' | translate}}</label>
                                                            <span>{{info.fullName}}</span>
                                                        </div>
                                                    </div>

                                                    <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                                                        <div class="rbt-form-group">
                                                            <label for="fullname">{{'bankName' | translate}}</label>
                                                            <span>{{info.bankName}}</span>
                                                        </div>
                                                    </div>

                                                    <div class="col-lg-6 col-md-6 col-sm-6 col-12" style="margin-top: 20px;">
                                                        <div class="rbt-form-group">
                                                            <label for="fullname">{{'bankAccountNo' | translate}}</label>
                                                            <span>{{info.bankAccountNo}}</span>
                                                        </div>
                                                    </div>

                                                    <div class="col-lg-6 col-md-6 col-sm-6 col-12" style="margin-top: 20px;">
                                                        <div class="rbt-form-group">
                                                            <label for="fullname">{{'iban' | translate}}</label>
                                                            <span>{{info.iban}}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <img (click)="deleteBankInfo(info.id)" class="deleteIco" src="../../../assets/images/trashIco.png" alt="{{'delete' | translate}}" title="{{'delete' | translate}}">
                                            </div>
                                            <div *ngIf="nobankData" class="nobankData">
                                                <h3>{{'nobankData' | translate}}</h3>
                                            </div>
                                            <div class="row" *ngIf="!nobankData">
                                                <div class="col-lg-12 mt--60">
                                                    <pagination-controls 
                                                    class="rbt-pagination" 
                                                    (pageChange)="p = $event"
                                                    previousLabel=""
                                                    nextLabel=""
                                                    ></pagination-controls>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
